/**
 * The app applies a global CSS `zoom` to `body` (see `index.css`) to scale the
 * whole UI up. `zoom` scales already-rendered pixels, so anything drawn into a
 * <canvas> (Chart.js) gets resampled by that factor and comes out soft/blurry:
 * Chart.js sizes its backing store from `window.devicePixelRatio` alone and has
 * no idea an extra 1.15x is applied on top.
 *
 * Fix: tell Chart.js to render at `devicePixelRatio * UI_ZOOM` so the bitmap is
 * already big enough for the post-zoom on-screen size.
 *
 * KEEP `UI_ZOOM` IN SYNC WITH `body { zoom: … }` IN index.css.
 */
export const UI_ZOOM = 1.15;

/** Device pixel ratio Chart.js should render at, accounting for `UI_ZOOM`. */
export function chartPixelRatio(): number {
  const dpr = typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1;
  // Cap at 4 — beyond that the memory cost outweighs any visible sharpness.
  return Math.min(4, dpr * UI_ZOOM);
}
